// extracted by mini-css-extract-plugin
export default {"container":"header-description_container__DGH6a"};